import { SingleRowAction, MultiRowAction, SelectAllAction, CRMSelectAllOptions } from '@galaxy/crm/static';
import { Row } from '@vendasta/galaxy/table';
import { EmailWorkflowService } from './email-workflow.service';

export function EmailSingleRowAction(
  namespace: string,
  userId: string,
  service: EmailWorkflowService,
  label: string,
  returnUrl: string,
  route: string[],
): SingleRowAction {
  return {
    label: label,
    callback: (row) => {
      service.navigateToEmailBuilderFromRows(namespace, userId, [row], returnUrl, route);
    },
  };
}

export function EmailMultiRowAction(
  namespace: string,
  userId: string,
  service: EmailWorkflowService,
  label: string,
  returnUrl: string,
  route: string[],
): MultiRowAction {
  return {
    label: label,
    callback: (rows) => {
      service.navigateToEmailBuilderFromRows(namespace, userId, rows, returnUrl, route);
    },
  };
}

export function EmailSelectAllRowAction(
  namespace: string,
  userId: string,
  service: EmailWorkflowService,
  label: string,
  returnUrl: string,
  route: string[],
): SelectAllAction {
  return {
    label: label,
    callback: (rows: Row[], _options?: CRMSelectAllOptions) => {
      service.navigateToEmailBuilderFromRows(namespace, userId, rows, returnUrl, route);
    },
  };
}

